import { Container, Typography } from '@cleartrip/ct-design-components'
import React, { useState } from 'react'

import { DownChevronNew } from '@/assets/icons/DownChevron'

type FilterAccordionProps = {
  title: string
  /** Badge right of the title; hidden when zero or undefined. */
  count?: number
  clearText?: string
  onClearClick?: () => void
  defaultOpen?: boolean
  children: React.ReactNode
}

const CLEAR_COLOR = '#0F6BFF'
const BADGE_SIZE = { width: '16px', height: '16px' }

const FilterAccordion = ({
  children,
  clearText = '',
  count,
  defaultOpen = true,
  onClearClick,
  title,
}: FilterAccordionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const toggle = () => setIsOpen(open => !open)

  return (
    <Container className='flex flex-column flex-rg-3'>
      <Container className='flex flex-middle flex-cg-2'>
        <Container className='flex flex-1 flex-middle flex-cg-2 ta-left bn bg-transparent p-0 c-pointer' onClick={toggle}>
          <Typography variant='HM3'>{title}</Typography>
          {!!count && (
            <Container className='flex flex-center flex-middle br-50p bg-neutral-900' css={BADGE_SIZE}>
              <Typography color='neutral' variant='TAG'>
                {count}
              </Typography>
            </Container>
          )}
        </Container>

        {clearText && !!count && (
          <Container className='bn bg-transparent p-0 c-pointer' onClick={onClearClick}>
            <Typography colorCode={CLEAR_COLOR} variant='L3'>
              {clearText}
            </Typography>
          </Container>
        )}

        <Container className='flex bn bg-transparent p-0 c-pointer' onClick={toggle}>
          <DownChevronNew className={isOpen ? 'tr-180' : undefined} height={20} width={20} />
        </Container>
      </Container>

      {isOpen && children}
    </Container>
  )
}

export default FilterAccordion
